import { FAIcon, Theme, TagStyle, Tag, SearchDataStructure, AttributeTypes,IconStyle } from '../../../ui/components';
import { GetColumnsType ,GetBulkActionOptionType} from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';
import { DropDownData } from '../../../ui/components/Form/DropDown/types/propsType';
import { RewardStatus } from '../../../ui/components/BulkActionModal/types/enums';
import { convertLocalDate} from '../../../ui/utils/helper';

export interface MasterData {
  campaign: {
    campaignEnd?: string;
    campaignId?: string;
    campaignName?: string;
    campaignStart: string;
    recId?: number;
    status?: string;
  }[];
  reward?: {
    recId: number;
    rewardCode: string;
    rewardName: string;
  }[];
}
export interface CampaignOption {
  campaignEnd: string;
  campaignId: string;
  campaignName: string;
  campaignStart: string;
  status: string;
  title: string;
  value: string;
}

export interface RedemptionData {
  campaignId: string;
  campaignName: string;
  campaignStart: string;
  campaignEnd: string;
  orderNumber: string;
  chances: number;
  orderAboId: string;
  volumeAboId: string;
  locationCode: string;
  locationName: string;
  channel: string;
  status: string;
  rewards : [{
    recId: number;
    attempt: number;
    aboId: string;
    rewardCode: string;
    rewardName: string;
  }]
}

export interface BulkActionItem {
  id: string;
  title: string;
  value: string;
  icon: string;
}

export interface BulkActionOption {
  name: string;
  placeholder: string;
  dataset: DropDownData[];
}

export const dataSearchOption: SearchDataStructure[] = [
  {
    name: 'Order Number',
    key: 'orderNumber',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Location Name',
    key: 'locationName',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Claimed Date',
    key: 'claimedDate',
    type: AttributeTypes.DateTimeSingle,
    visibility: true,
  },
  {
    name: 'Ordering ABO',
    key: 'orderAboName',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'VolumeTo ABO',
    key: 'volumeAboName',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Reward Status',
    key: 'status',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'distributed',
        value: 'DISTRIBUTED',
      },
      {
        key: 'selected',
        value: 'SELECTED',
      },
      {
        key: 'cancelled',
        value: 'CANCELLED',
      },
    ],
  },
  {
    name: 'Completion Status',
    key: 'completionStatus',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'completed',
        value: 'COMPLETED',
      },
      {
        key: 'pending',
        value: 'PENDING',
      },
    ],
  },
];

type IRedemptionBO = {
  [key: string]: DynamicObjectInterface;
};

export const getRedemptionListConfig: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'orderNumber',
    text: translation('admin.redemption.orderNumber'),
    width: 4,
    sortable: true,
    render: (object: IRedemptionBO) => <span>{object.orderNumber}</span>,
  },
  {
    key: 'orderAboName',
    text: translation('admin.redemption.orderAboId'),
    width: 8,
    sortable: true,
    render: (object: IRedemptionBO) => <span>{object.orderAboName}</span>,
  },
    {
    key: 'volumeAboName',
    text: translation('admin.redemption.volumeAboId'),
    width: 8,
    sortable: true,
    render: (object: IRedemptionBO) => <span>{object.volumeAboName}</span>,
  },
  {
    key: 'locationName',
    text: translation('admin.redemption.locationName'),
    width: 8,
    sortable: true,
    render: (object: IRedemptionBO) => <span>{object.locationName}</span>,
  },
  // {
  //   key: 'channel',
  //   text: translation('admin.redemption.channel'),
  //   width: 3,
  //   sortable: true,
  //   render: (object: IRedemptionBO) => <span>{object.channel}</span>,
  // },
  {
    key: 'claimedDate',
    text: translation('admin.redemption.createdDate'),
    sortable: true,
    width: 4,
    render: (object: IRedemptionBO) => (
      <span>{convertLocalDate(object.claimedDate)}</span>
    ),
  },
  {
    key: 'attempt',
    text: translation('admin.redemption.attempt'),
    width: 2,
    sortable: true,
    render: (object: IRedemptionBO) => <span>{object.attempt} / {object.chances}</span>,
  },
  // {
  //   key: 'completionStatus',
  //   text: translation('admin.redemption.completionStatus'),
  //   width: 4,
  //   sortable: true,
  //   render: (object: IRedemptionBO) => (
  //     <span>
  //       <Tag
  //         theme={object.completionStatus === 'COMPLETED' ? Theme.SUCCESS : Theme.WARNING}
  //         style={TagStyle.OUTLINE}
  //         text={object.completionStatus}
  //       />
  //     </span>
  //   ),
  // },
  {
    key: 'status',
    text: translation('admin.redemption.status'),
    sortable: true,
    width: 4,
    render: (object: IRedemptionBO) => (
      <span>
        <Tag
          theme={object.status === 'DISTRIBUTED' ? Theme.SUCCESS : object.status === 'CANCELLED' ? Theme.ERROR : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  {
     key: 'action',
     width: 4,
     text: 'Actions',
     render: (object: IRedemptionBO) => (
       <>
         <FAIcon
           iconName={'edit'}
           onClick={e => {
             cb?.onEdit(object.orderNumber);
             e.stopPropagation();
           }}
           theme={Theme.PURPLE}
           title={'Edit'}
         />
         {' | '}
         <FAIcon
           iconName={'print'}
           iconStyle={IconStyle.SOLID}
           onClick={e => {
             cb?.onPrint(object.orderNumber);
             e.stopPropagation();
           }}
           theme={Theme.PURPLE}
           title={'Print'}
         />
       </>
     ),
   },
];



export const bulkActionOption: GetBulkActionOptionType = (cb: DynamicObjectInterface) => {
  return {
    name: 'redemption-bulk-action',
    placeholder: 'Actions',
    dataset: [
      {
        id: 'Edit',
        title: 'Edit',
        value: 'Edit',
        icon: 'pen-to-square',
        onClick: (e: DynamicObjectInterface) => {
          cb?.onBulkEdit();
        },
      },
      // {
      //   id: 'Delete',
      //   title: 'Delete',
      //   value: 'Delete',
      //   icon: 'trash-can',
      //   onClick: (e: DynamicObjectInterface) => {
      //     cb?.onBulkDelete();
      //   },
      // },
    ],
  };
};

export const bulkActionEditConfig: DynamicObjectInterface = (translation: DynamicObjectInterface) => [
 {
  name: 'rewardStatus',
  label: 'Reward Status',
  type: 'checkboxRadio',
  optionsLayout: 'block',
  options: [
    { label: 'SELECTED', value: RewardStatus.SELECTED },
    { label: 'DISTRIBUTED', value: RewardStatus.DISTRIBUTED },
  ],
 }
];

export const getRewardListConfig: GetColumnsType = (styles: Object, translation: Function, cb: DynamicObjectInterface) => [
    {
    key: 'attempt',
    text: translation('admin.redemption.number'),
    sortable: true,
    width: 2,
    render: (object: IRedemptionBO) => <span>{object.attempt}</span>,
  },
  {
    key: 'rewardName',
    text: translation('admin.redemption.rewardName'),
    sortable: true,
    width: 7,
    render: (object: IRedemptionBO) =><span>{object.rewardName}</span>,
  },
  {
    key: 'createdBy',
    text: translation('admin.redemption.claimBy'),
    sortable: true,
    width: 5,
    render: (object: IRedemptionBO) => <span>{object.player}</span>,
  },
  {
    key: 'createdDate',
    text: translation('admin.redemption.createdDate'),
    sortable: true,
    width: 4,
    render: (object: IRedemptionBO) => <span>{convertLocalDate(object.createdDate, 'DD/MM/YYYY HH:mm:ss')}</span>,
  },
];

